<template>
  <div v-if="bloquee" class="bandeau-hl rouge non-imprimable" role="alert">
    <i class="bi bi-exclamation-octagon-fill"></i>
    <span><strong>Caisse bloquée :</strong> {{ attente }} vente(s) hors ligne attendent depuis plus de {{ DELAI }} h. Reconnectez-vous à internet pour les envoyer et continuer à vendre.</span>
  </div>
  <div v-else-if="!horsLigne.joignable" class="bandeau-hl ambre non-imprimable" role="status">
    <i class="bi bi-wifi-off"></i>
    <span><strong>Pas de connexion.</strong> La caisse continue de vendre<template v-if="attente"> · {{ attente }} vente(s) en attente d'envoi</template>. Envoi automatique au retour d'internet.</span>
  </div>
  <div v-else-if="attente" class="bandeau-hl bleu non-imprimable" role="status">
    <span class="spinner-border spinner-border-sm"></span>
    <span>Envoi de {{ attente }} vente(s) faite(s) hors ligne…</span>
    <button class="btn btn-sm btn-light ms-auto" :disabled="horsLigne.envoiEnCours" @click="synchroniser">Envoyer maintenant</button>
  </div>
  <div v-if="horsLigne.rejetees.length" class="bandeau-hl rouge-clair non-imprimable" role="alert">
    <i class="bi bi-exclamation-triangle-fill"></i>
    <span>{{ horsLigne.rejetees.length }} vente(s) hors ligne refusée(s) par le serveur.</span>
    <button class="btn btn-sm btn-outline-danger ms-auto" @click="liste = true">Voir</button>
  </div>

  <Fenetre v-if="liste" titre="Ventes hors ligne refusées" taille="large" @fermer="liste = false">
    <p class="small text-muted">Ces ventes ont eu lieu (le client a payé et emporté), mais le serveur les a refusées. Corrigez la cause puis « Réessayer », ou ressaisissez la vente et retirez-la de cette liste.</p>
    <div v-for="v in horsLigne.rejetees" :key="v.cle" class="vente-refusee">
      <div class="d-flex justify-content-between flex-wrap gap-2">
        <strong>{{ v.numero }}</strong>
        <span class="small text-muted">{{ date(v.le, true) }}<template v-if="v.nomClient"> · {{ v.nomClient }}</template></span>
        <strong class="chiffre">{{ fcfa(v.total) }}</strong>
      </div>
      <div class="small">{{ (v.ticket?.lignes || []).map(l => `${qte(l.quantite)} × ${l.libelle}`).join(", ") }}</div>
      <div class="text-danger small mt-1"><i class="bi bi-x-circle"></i> {{ v.motif }}</div>
      <div class="d-flex gap-2 mt-2">
        <button class="btn btn-sm btn-primary" @click="reessayer(v.cle)">Réessayer</button>
        <button class="btn btn-sm btn-light" @click="retirer(v)">Ressaisie faite : retirer</button>
      </div>
    </div>
    <div v-if="!horsLigne.rejetees.length" class="text-muted">Aucune vente refusée.</div>
  </Fenetre>
</template>

<script>
import Fenetre from "@/components/commun/Fenetre.vue";
import { notifier } from "@/api";
import { fcfa, qte, date } from "@/utils/format";
import { horsLigne, synchroniser, reessayer, oublier, mesVentesEnAttente, caisseBloquee, DELAI_MAX_HEURES } from "@/horsLigne";

export default {
  name: "EtatHorsLigne",
  components: { Fenetre },
  data: () => ({ horsLigne, liste: false, DELAI: DELAI_MAX_HEURES, maintenant: Date.now(), minuterie: null }),
  computed: {
    attente() { return mesVentesEnAttente().length; },
    bloquee() { return this.maintenant && this.attente > 0 && caisseBloquee(); },
  },
  mounted() {
    window.addEventListener("ventes-hors-ligne-envoyees", this.envoyees);
    this.minuterie = setInterval(() => { this.maintenant = Date.now(); }, 60000);
  },
  beforeUnmount() {
    window.removeEventListener("ventes-hors-ligne-envoyees", this.envoyees);
    clearInterval(this.minuterie);
  },
  methods: {
    fcfa, qte, date, synchroniser, reessayer,
    envoyees(e) { notifier(`${e.detail.nombre} vente(s) faite(s) hors ligne envoyée(s) au serveur.`, "success"); },
    retirer(v) {
      if (confirm(`Retirer ${v.numero} de la liste ? Faites-le seulement si la vente a été ressaisie ou régularisée.`)) oublier(v.cle);
    },
  },
};
</script>

<style scoped>
.bandeau-hl { display: flex; align-items: center; gap: 10px; padding: 9px 20px; font-weight: 500; flex-wrap: wrap; }
.bandeau-hl.ambre { background: var(--ambre-clair); color: #6b4b10; }
.bandeau-hl.bleu { background: var(--indigo-50); color: var(--indigo-800); }
.bandeau-hl.rouge { background: var(--rouge); color: #fff; }
.bandeau-hl.rouge-clair { background: var(--rouge-clair); color: var(--rouge); }
.vente-refusee { border: 1px solid var(--trait); border-radius: 8px; padding: 10px 12px; margin-bottom: 10px; }
@media (max-width: 575px) { .bandeau-hl { padding: 8px 12px; font-size: .88rem; } }
</style>
